import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  Entidades,
  EntidadeMembros,
  Configuracoes,
  ChangePassword,
  BlacklistFundos,
  RecursoGarantidor,
} from "../../../pages";
import EntidadesProvider from "../../../contexts/EntidadesContext";
//import RecursoGarantidorProvider from "../../../contexts/RecursoGarantidorContext";
import { PATHS } from "../../../enums";

const ConfigRoutes = () => {
  return (
    <EntidadesProvider>
      {/* <RecursoGarantidorProvider tipo="entidade"> */}
      <Routes>
        <Route
          path={
            PATHS.configuracoes.nested.entidades.nested["recurso-garantidor"]
              .path
          }
          element={<RecursoGarantidor />}
        />
        <Route
          path={PATHS.configuracoes.nested.entidades.nested.membros.path}
          element={<EntidadeMembros />}
        />
        <Route
          path={PATHS.configuracoes.nested.entidades.path}
          element={<Entidades />}
        />
        <Route
          path={PATHS.configuracoes.nested["alterar-senha"].path}
          element={<ChangePassword />}
        />
        <Route
          path={PATHS.configuracoes.nested["fundos-fechados"].path}
          element={<BlacklistFundos />}
        />
        <Route path={"*"} element={<Configuracoes />} />
      </Routes>
      {/* </RecursoGarantidorProvider> */}
    </EntidadesProvider>
  );
};

export default ConfigRoutes;
